import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export interface LabelAtomProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  id?: string;
  state?: 'default' | 'error' | 'success';
  disabled?: boolean;
  htmlFor: string;
  value: string;
  optionalityLabel?: string;
}

const labelVariants = cva(
  [
    'preflight',
    'ds-form-label',
    '!ds-font-sans',
    'ds-text-base',
    'ds-cursor-pointer',
    'ds-w-[fit-content]'
  ],
  {
    variants: {
      state: {
        default: ['ds-text-neutrals-black'],
        error: ['ds-text-danger-red-darkest'],
        success: ['ds-text-success-green-darkest']
      },
      disabled: {
        true: '!ds-text-neutrals-dark'
      }
    }
  }
);

interface LabelAtomVariants extends VariantProps<typeof labelVariants> {}
export const labelStyles = (variants: LabelAtomVariants) =>
  twMerge(labelVariants(variants));

const LabelAtom = ({
  id,
  state = 'default',
  disabled = false,
  htmlFor,
  value = '',
  optionalityLabel = ''
}: LabelAtomProps) => {
  return (
    <label id={id} htmlFor={htmlFor} className={labelStyles({ state, disabled })}>
      {value}
      {optionalityLabel && (
        <span className="ds-text-sm ds-text-neutrals-darker">{` (${optionalityLabel})`}</span>
      )}
    </label>
  );
};

export default LabelAtom;
